// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3UUM7","disabled":"FileBtn_disabled__2maHR","warn":"FileBtn_warn__8UQ2K","fade":"FileBtn_fade__1qIji"};